import { menusApi } from "@src/service/menus";
import { getRequestError } from "@src/utils/getRequestError";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { fetchMenuProduct } from "../menu/actionCreators";
import {
  FETCH_ATTRIBUTES_AND_PRODUCTS_PROCESS,
  FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR,
  FETCH_ATTRIBUTES_AND_PRODUCTS_SAGA,
  FETCH_ATTRIBUTES_AND_PRODUCTS_SUCCESS,
  ADD_ATTRIBUTE_TO_ATTRIBUTE_GROUP_SAGA,
  FETCH_EXIST_ATTRIBUTE_GROUP_SUCCESS,
  FETCH_ATTRIBUTE_GROUP_SAGA,
  EDIT_ATTRIBUTE_GROUP_SAGA,
  FETCH_ATTRIBUTE_GROUP_DETAIL_SAGA,
  FETCH_ATTRIBUTES_DETAIL_SUCCESS,
  FETCH_ATTRIBUTE_GROUP_PRODUCTS_SAGA,
  FETCH_ATTRIBUTES_GROUP_PRODUCTS_PROCESS,
  FETCH_ATTRIBUTES_GROUP_PRODUCTS_SUCCESS,
  FETCH_ATTRIBUTES_GROUP_PRODUCTS_ERROR,
  UPDATE_ATTRIBUTE_GROUP_ERROR,
  UPDATE_ATTRIBUTE_GROUP_PROCESS,
  UPDATE_ATTRIBUTE_GROUP_SAGA,
  FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SUCCESS,
  FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SAGA,
} from "./types/types";
import { fetchAttributeGroup } from "@src/store/attributes/actionCreators";
import { LoadingStatus } from "../generals/types";

export function* fetchAttributesAndProductsRequest(action: any): any {
  try {
    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_PROCESS });

    const { menu_id, product_id, attribute_group_name, min, max } =
      action.payload;

    const { currLocation } = yield select((state) => state.appManager);

    const { data } = yield call(
      menusApi.getAttributeProductList,
      currLocation,
      menu_id,
      product_id,
      attribute_group_name,
      min,
      max
    );

    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_SUCCESS, payload: data });
  } catch (e: any) {
    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR });

    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* fetchAttributeGroupRequest(action: any): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const { menu_id, search, page } = action.payload;

    const { currLocation } = yield select((state) => state.appManager);

    const { data } = yield call(
      menusApi.getAttributeGroup,
      currLocation,
      menu_id,
      search,
      page
    );

    yield put({ type: FETCH_EXIST_ATTRIBUTE_GROUP_SUCCESS, payload: data });

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));

    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR });
  }
}

export function* fetchInfityScrollAttributeGroupsRequest(action: any): any {
  try {
    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_PROCESS });

    const { menu_id, search, page } = action.payload;

    const { currLocation } = yield select((state) => state.appManager);

    const { data } = yield call(
      menusApi.getAttributeGroup,
      currLocation,
      menu_id,
      search,
      page
    );

    yield put({
      type: FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SUCCESS,
      payload: data,
    });
  } catch (e) {
    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR });
  }
}

export function* addAttributeToAttributeGroupRequest(action: any): any {
  try {
    const { currLocation } = yield select((state) => state.appManager);

    const { menu_id, product_id, ...rest } = action.payload;

    const { data } = yield call(
      menusApi.addAttributetoAttributeGroup,
      currLocation,
      menu_id,
      rest
    );

    yield put(
      setSnackbar({
        visible: true,
        message: "Запрос успешно отправлен",
        status: "success",
      })
    );
    yield put(fetchMenuProduct({ menuId: menu_id, productId: product_id }));
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}
export function* editAttributeGroupRequest(action: any): any {
  try {
    const { currLocation } = yield select((state) => state.appManager);
    const { menu_id, body } = action.payload;

    yield call(menusApi.editAttributeGroup, currLocation, menu_id, body);

    yield put(
      setSnackbar({
        visible: true,
        message: "Success Edited",
        status: "success",
      })
    );
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}
export function* getAttributeGroupDetail(action: any): any {
  try {
    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_PROCESS });

    const { currLocation } = yield select((state) => state.appManager);

    const { menuId, productId, attributeGroupId } = action.payload;

    const { data } = yield call(
      menusApi.getAttributeGroupDetails,
      currLocation,
      menuId,
      productId,
      attributeGroupId
    );

    yield put({ type: FETCH_ATTRIBUTES_DETAIL_SUCCESS, payload: data });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );

    yield put({ type: FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR });
  }
}
export function* getAttributeGroupProductsRequest(action: any): any {
  try {
    yield put({ type: FETCH_ATTRIBUTES_GROUP_PRODUCTS_PROCESS });

    const { menu_id, attribute_group_id } = action.payload;

    const { data } = yield call(
      menusApi.getAttributeGroupProducts,
      menu_id,
      attribute_group_id
    );

    yield put({
      type: FETCH_ATTRIBUTES_GROUP_PRODUCTS_SUCCESS,
      payload: { id: attribute_group_id, products: data },
    });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );

    yield put({ type: FETCH_ATTRIBUTES_GROUP_PRODUCTS_ERROR });
  }
}

export function* updateAttributeGroupRequest(action: any): any {
  try {
    yield put({ type: UPDATE_ATTRIBUTE_GROUP_PROCESS });

    const { menu_id, attribute_group_id } = action.payload;

    yield call(menusApi.deleteAttributeGroup, menu_id, {
      attribute_group_ext_id: attribute_group_id,
    });

    yield put(fetchAttributeGroup(menu_id));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );

    yield put({ type: UPDATE_ATTRIBUTE_GROUP_ERROR });
  }
}

export function* attributesSaga(): any {
  yield takeLatest(
    FETCH_ATTRIBUTES_AND_PRODUCTS_SAGA,
    fetchAttributesAndProductsRequest
  );
  yield takeLatest(UPDATE_ATTRIBUTE_GROUP_SAGA, updateAttributeGroupRequest);
  yield takeLatest(
    ADD_ATTRIBUTE_TO_ATTRIBUTE_GROUP_SAGA,
    addAttributeToAttributeGroupRequest
  );
  yield takeLatest(FETCH_ATTRIBUTE_GROUP_SAGA, fetchAttributeGroupRequest);
  yield takeLatest(EDIT_ATTRIBUTE_GROUP_SAGA, editAttributeGroupRequest);
  yield takeLatest(FETCH_ATTRIBUTE_GROUP_DETAIL_SAGA, getAttributeGroupDetail);
  yield takeLatest(
    FETCH_ATTRIBUTE_GROUP_PRODUCTS_SAGA,
    getAttributeGroupProductsRequest
  );
  yield takeLatest(
    FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SAGA,
    fetchInfityScrollAttributeGroupsRequest
  );
}
